import{createSlice as t}from"@reduxjs/toolkit";const e=t({name:"authToken",initialState:null,reducers:{authTokenSet:(t,e)=>e.payload}}),{authTokenSet:a}=e.actions;var o=e.reducer;export{a as authTokenSet,o as default};
